export const ITEM_HEIGHT = 51
export const MAX_DISPLAYED_ITEMS = 10
